import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import ErrorPage from './views/Error/Error.page';
// import SummerCampForm from './components/multiForm/SummerCampForm';
import { createBrowserRouter, RouterProvider } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById('root'));
const router = createBrowserRouter([
  // {
  //   path: "/summer-meal",
  //   element: <SummerCampForm />,
  //   errorElement: <ErrorPage />
  // },
  {
    path: "/:?ref?",
    element: <App />,
    errorElement: <ErrorPage />
  }
]);


root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

reportWebVitals();